module.exports = __webpack_public_path__ + "media/images/countrysquared/bh-74b8a1938ab9fb3b9cffd8c37e67b2cb.svg";